<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <ul class="vx-timeline">
      <li v-for="item in data" :key="item.title">
          <div class="timeline-icon" :class="`bg-${item.color}`">
              <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div class="timeline-info mb-2">
              <p class="font-semibold mb-2">{{ item.title }} <vs-button type="flat" v-if="isMe" size="small" color="primary" icon-pack="feather" icon="icon-edit" class="ml-1" style="display: inline" @click="$emit('edit', item.edu)"></vs-button></p>
              <span class="activity-desc">{{ item.desc }} <small class="text-grey">{{ item.edu.title && item.edu.title != '-' ? ' - ' + item.edu.title : '' }}</small></span>
          </div>
          <small class="text-grey activity-e-time">{{ item.time }}</small>
      </li>
  </ul>
</template>

<script>
export default {
  name: 'vx-timeline',
  props: {
    data: {
      type: Array,
      required: true,
    },
    isMe: Boolean,
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
